import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "submitButton", "itemizedBills", "billsPopup", "arrow", "billsContainer",
    "nIter", "enableHrCheckbox" // We'll watch these
  ]
  static values = {
    costPerImageWithoutHr: Number, // e.g. 0.01
    costPerImageWithHr: Number,    // e.g. 0.02
  }

  connect() {
    // Hide popup
    this.billsContainerTarget.classList.add("hidden")
    this.billsPopupTarget.classList.add("hidden")

    // We'll calculate cost whenever n_iter or enable_hr changes
    this.calculateCosts()

    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.billsPopupTarget.classList.add("hidden")
      this.arrowTarget.classList.remove("rotate-180")
    }
  }

  calculateCosts() {
    // Grab n_iter
    const nIter = parseInt(this.nIterTarget.value || "1", 10)
    // Grab whether HR is enabled
    const enableHr = this.enableHrCheckboxTarget.checked

    // costPerImage depends on HR
    const costPerImage = enableHr ? this.costPerImageWithHrValue : this.costPerImageWithoutHrValue
    const totalCost = nIter * costPerImage
    const roundedCost = Math.ceil(totalCost * 100) / 100

    // Update button
    const span = this.submitButtonTarget.querySelector("span:last-child")
    if (span) span.textContent = `Generate (${roundedCost} Credits)`

    // Show itemized bills
    if (nIter > 0) {
      this.billsContainerTarget.classList.remove("hidden")
      this.itemizedBillsTarget.innerHTML = this.generateItemizedBillsHTML(nIter, costPerImage, roundedCost)
    } else {
      this.resetDisplay()
    }
  }

  resetDisplay() {
    const span = this.submitButtonTarget.querySelector("span:last-child")
    if (span) span.textContent = "Generate"
    this.billsContainerTarget.classList.add("hidden")
    this.billsPopupTarget.classList.add("hidden")
    this.arrowTarget.classList.remove("rotate-180")
  }

  generateItemizedBillsHTML(nIter, costPerImage, totalCost) {
    let html = '<div class="text-white space-y-3">'
    html += '<div class="text-lg font-medium text-gray-200 mb-3">Cost Breakdown</div>'
    html += '<div class="border border-dashed border-gray-600 rounded-lg p-4 space-y-3">'

    // The line: "Images: n_iter × costPerImage"
    html += `<div class="flex justify-between items-center text-sm">
      <span>Generations (${nIter} × ${costPerImage} credits)</span>
      <span>${(nIter * costPerImage).toFixed(2)} credits</span>
    </div>`

    html += '</div>' // close dashed border

    // total
    html += `
      <div class="flex justify-between items-center pt-3 text-sm font-medium">
        <span>Total:</span>
        <span class="flex items-center gap-1">
          <svg class="w-4 h-4 text-blue-400" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 
                     10 10 10 10-4.48 10-10S17.52 2 
                     12 2zm0 18c-4.41 0-8-3.59-8-8s3.59
                     -8 8-8 8 3.59 8 8-3.59 8-8 8zm-1
                     -13h2v6h-2zm0 8h2v2h-2z"/>
          </svg>
          ${totalCost.toFixed(2)}
        </span>
      </div>
    `
    html += '</div>'
    return html
  }

  toggleBills(event) {
    event.stopPropagation()
    this.billsPopupTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-180")
  }

  // If the user changes the nIter or the HR checkbox, we recalc
  nIterChanged() {
    this.calculateCosts()
  }

  hrCheckboxChanged() {
    this.calculateCosts()
  }
} 